import { call, put, select, cancelled } from 'redux-saga/effects';

import { withApiErrorHandling } from 'utils/redux/sagaHelper';
import { statsService } from 'utils/api';

import session from 'containers/App/session';

import { createActions, createReducer, createSagaWatcher, createSelectors } from '../generators';

const KEY = 'otaInsightsDailyWithChange';
const PARAMETERS = ['propertyId', 'date'];
const actions = createActions(KEY, PARAMETERS);
const { fetchCancelled, fetchStarted, fetchSucceeded, fetchFailed } = actions;

function* fetchSaga(action) {
    try {
        const { params } = action;
        const { propertyId, date } = params;
        yield put(fetchStarted(params));
        const token = yield select(session.selectors.selectUserToken);
        const { response, error } = yield call(
            withApiErrorHandling,
            statsService({ token, propertyId }).getDailyOTAInsightsWithChange,
            { today: date },
        );

        if (response) {
            yield put(fetchSucceeded(response.data));
        } else {
            yield put(fetchFailed(error));
        }
    } catch (error) {
        yield put(fetchFailed(error));
    } finally {
        if (yield cancelled()) yield put(fetchCancelled());
    }
}

export default {
    KEY,
    actions,
    reducer: createReducer(KEY),
    saga: createSagaWatcher(KEY, fetchSaga),
    selectors: createSelectors(KEY),
};

export { fetchSaga };
